/**
 * Determine whether an impact is in the resolved state.
 *
 * @param {Object} impact - Impact record
 * @returns {boolean} True if the impact's status is 'resolved'
 */
export const isResolvedImpact = (impact) => impact?.status === 'resolved';
